/* file description */

export const filterTableSchema = [
  {
    title: '部件需求',
    namespaceID: 'master_data',
    moduleID: 'md_cpart_bom',
    columns: [
      { dataIndex: 'need' },
    ],
  },
  {
    title: '部件特征',
    namespaceID: 'master_data',
    moduleID: 'md_cpart_product_feature_info',
    columns: [
      { dataIndex: 'bd_feature_type_classification_number' },
      { dataIndex: 'feature_code' },
      { dataIndex: 'feature_value_code' },
      { dataIndex: 'comments' },
    ],
  },
  {
    title: '特征附件',
    namespaceID: 'master_data',
    moduleID: 'cpart_feature_attachments',
    columns: [
      { dataIndex: 'feature_type' },
      { dataIndex: 'oss_path' },
      { dataIndex: 'comments' },
    ],
  },
  {
    title: '部件主材',
    namespaceID: 'master_data',
    moduleID: 'cpart_main_material',
    columns: [
      { dataIndex: 'material_code' },
      { dataIndex: 'source_bd_material_classification_number' },
      { dataIndex: 'material_model' },
      { dataIndex: 'unit_code' },
      { dataIndex: 'quantity' },
      { dataIndex: 'supplier_org_code' },
    ],
  },
];
